import types from '../actions/types';

const initialState = {
  usageAreas: [],
  carBrands: [],
  carYears: [],
  carModels: [],
};

const cleanableState = {
  carUsageArea: null,
  carBrand: null,
  carYear: null,
  carModel: null,

  carMotor: '',
  carChassis: '',
  is0Km: false,
  carMatricula: '',
  carPadron: '',

  vehicleType: '',
  truckWeight: false,
  hasAssistance: true,
  economic: false
};

const vehicles = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};
      
    case types.SET_VEHICLES_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    case types.GO_BACK_AUTO: {
      const { cleanValue } = action.payload;
      return {
        ...state,
        carUsageArea: cleanValue === 0 ? null : state.carUsageArea,
        carModel:  cleanValue > 0 ? null : state.carModel,
        carYear:   cleanValue > 1 ? null : state.carYear,
        carBrand:  cleanValue > 2 ? null : state.carBrand,
        carModels: cleanValue > 1 ? []   : state.carModels,
        carYears:  cleanValue > 2 ? []   : state.carYears,
      }
    }

    default:
      return state;
  }
};

export default vehicles;
